import type { IOrganization, IUserOrganization } from '@mcn-platform/models';

type StoreWithOrgLinks = {
  currentOrganization: IOrganization | undefined;
  currentUserOrganizations: IUserOrganization[];
};

/**
 * Part of admin assistant access: UserOrganization for the current org must have `superUser: true`.
 * The UI also requires `User.enableAdminAgent` (see AdminLayout).
 */
export function isSuperUserForCurrentOrg(store: StoreWithOrgLinks): boolean {
  const org = store.currentOrganization;
  if (!org?.id) return false;
  const link = store.currentUserOrganizations.find(
    (uo) => uo.organization?.id === org.id,
  );
  return Boolean(link?.superUser);
}
